import {useEffect} from 'react';
import {fetchTrackFromJsonFeed, fetchTrackFromTextFeed, fetchTrackFromXmlFeed} from "../features/stations/stationUtils";

/**
 * Custom hook for polling "now playing" data for stations.
 * @param {Array} stations - The list of stations to poll.
 * @param {Function} setNowPlaying - Function to update the "now playing" state.
 * @param {number} interval - Polling interval in milliseconds (default: 30 seconds).
 * @returns {void}
 */
function useNowPlaying(stations, setNowPlaying, interval = 30000, currentStation) {
	useEffect(() => {
		if (!currentStation) return;

		const controller = new AbortController();

		const pollNowPlaying = async () => {
			try {
				let track = null;
				if (currentStation.nowPlayingFormat === "json") {
					track = await fetchTrackFromJsonFeed(currentStation.nowPlayingUrl, controller.signal);
				} else if (currentStation.nowPlayingFormat === "text") {
					track = await fetchTrackFromTextFeed(currentStation.nowPlayingUrl, controller.signal);
				} else if (currentStation.nowPlayingFormat === "xml") {
					track = await fetchTrackFromXmlFeed(currentStation.nowPlayingUrl, controller.signal);
				}

				setNowPlaying((prev) => ({
					...prev,
					[currentStation.id]: track,
				}));
			} catch (error) {
				console.error("Error fetching now playing data:", error);
			}
		};

		// Start polling
		pollNowPlaying(); // Initial fetch
		const intervalId = setInterval(pollNowPlaying, interval);

		// Cleanup on unmount
		return () => {
			controller.abort();
			clearInterval(intervalId)
		};
	}, [currentStation, setNowPlaying, interval]);
}

export default useNowPlaying;
